import { render, staticRenderFns } from "./UserDashboardMeta.vue?vue&type=template&id=cde23cb0&scoped=true&"
import script from "./UserDashboardMeta.vue?vue&type=script&lang=js&"
export * from "./UserDashboardMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde23cb0",
  null
  
)

export default component.exports